module.exports = __webpack_public_path__ + "static/media/loader.f3421051.gif";